import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.css';
import Mafia from './components/mafia';
import './components/app.css'

ReactDOM.render(<Mafia />, document.getElementById('root'));
